import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import Login from '../pages/Login/index.tsx';
import MainLayout from '../components/MainLayout';
import Dashboard from '../pages/Dashboard';
import Devices from '../pages/Devices';
import Simulates from '../pages/Simulates';
import UserManagement from '../pages/UserManagement/index.tsx';
import Profile from '../pages/Profile/index.tsx';

// 路由守卫组件
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// 管理员路由守卫组件
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const userInfo = localStorage.getItem('user');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (userInfo) {
    const user = JSON.parse(userInfo);
    if (user.role !== 'admin') {
      // 非管理员访问管理员页面，重定向到首页
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'devices',
        element: <Devices />,
      },
      {
        path: 'simulates',
        element: <Simulates />,
      },
      {
        path: 'users',
        element: (
          <AdminRoute>
            <UserManagement />
          </AdminRoute>
        ),
      },
      {
        path: 'profile',
        element: <Profile />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/dashboard" replace />,
  },
]);

export default router;
